var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},_vm._l((_vm.alerts),function(alert,key){return _c('div',{key:key,staticClass:"alert",class:_vm.getClass(alert.type),domProps:{"textContent":_vm._s(alert.content)}},[_c('span')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }